export default __webpack_public_path__ + "static/media/LeaseIcon.e558e70d.svg";